<template>
  <el-upload
    v-if="drag"
    :before-upload="handleBeforeUpload"
    :http-request="handleHttpRequest"
    :on-change="handleChange"
    :on-progress="handleProgress"
    :show-file-list="false"
    accept="image/*"
    action="#"
    class="nf-upload-image nf-unload-image-drag"
    drag
    list-type="picture-card"
    multipl
    :disabled="disabled"
  >
    <slot />
  </el-upload>
  <el-upload
    v-else
    :before-upload="handleBeforeUpload"
    :class="multiple ? 'nf-unload-image-multiple' : ''"
    :http-request="handleHttpRequest"
    :multiple="multiple"
    :on-change="handleChange"
    :on-progress="handleProgress"
    :show-file-list="false"
    accept="image/*"
    action="#"
    class="nf-upload-image"
    list-type="picture-card"
    :disabled="disabled"
    drag
  >
    <div v-if="multiple" class="multiple-text">
      <el-button class="nf-unload-image-multiple-button" size="mini" type="primary"
        >上传证件
      </el-button>
    </div>
    <template v-else-if="!multiple">
      <div class="ca-value">
        <div v-if="!value && guakaoStyle" class="uploadph"><i class="el-icon-plus"></i></div>
        <img
          v-else-if="!value && onlyUploadImg"
          alt=""
          class="ca-cover-img"
          src="@/assets/images/capacity/shangchuan.png"
        />
        <img
          v-else-if="!value"
          alt=""
          class="ca-value-img"
          src="@/assets/images/capacity/kongimg.png"
        />
        <template v-else>
          <nf-image
            :ref="code"
            :preview-src-list="previewList"
            :src="value"
            class="ca-value-img"
            fit="fill"
          />
          <i class="ca-remove el-icon-error" @click.stop="handleRemove" v-if="removeExist"></i>
          <div class="ca-pop">
            <i class="el-icon-view" @click.stop="handlePreview"></i>
            <i class="el-icon-upload2"></i>
          </div>
        </template>
      </div>
    </template>
  </el-upload>
</template>

<script>
import nfImage from '@/components/nf-image';
import * as imageConversion from 'image-conversion';

export default {
  name: 'nfUploadImage',
  components: { nfImage },
  props: {
    code: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    drag: {
      type: Boolean,
      default: false,
    },
    groupId: {
      type: String,
      default: '',
    },
    filePath: {
      type: String,
      default: '',
    },
    imageTypes: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    previewList: {
      type: Array,
      default: () => [],
    },
    openCompression: {
      type: Boolean,
      default: true,
    },
    onlyUploadImg: {
      type: Boolean,
      default: false,
    },
    removeExist: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    guakaoStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errorList: [],
    };
  },
  computed: {
    whetherUpdateWaybill() {
      return this.$store.state.waybill.whetherUpdateWaybill;
    },
  },
  methods: {
    // 图片上传之前判断处理
    handleBeforeUpload(file, fileList) {
      const isPng = file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 30;
      if (!isPng) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 30MB!');
        return false;
      }
      return isPng && isLt2M;
    },
    // 压缩图片 imageConversion
    compressionPicture(file, size) {
      return new Promise((resolve, reject) => {
        imageConversion.compressAccurately(file, size).then(res => {
          const compressed_file = new File([res], file.name, {
            type: file.type,
            lastModified: Date.now(),
          });
          compressed_file.uid = file.uid;
          return resolve(compressed_file);
        });
      });
    },
    // 拦截原生上传
    handleHttpRequest(file) {
      let uploadFile = '';
      if (this.openCompression) {
        this.compressionPicture(file.file, 5000).then(res => {
          this.imageUpload(res);
        });
      } else {
        uploadFile = file.raw;
        this.imageUpload(uploadFile);
      }
    },
    // 封装上传
    imageUpload(file) {
      console.log(file);
      if (this.onlyUploadImg) {
        this.$emit('handleAvatarSuccess', file);
      } else {
        const url = '/rest/upload/v3/uploadBatches';
        const formData = new FormData();
        formData.append('files', file);
        formData.append('groupId', this.groupId);
        formData.append('filePath', this.filePath);
        // if (this.code) formData.append('imageTypes', this.code);

        this.$http.post(url, formData).then(res => {
          if (res.message !== '成功') {
            this.$$message(
              '上传失败1，可能是证件照片不规范（变形、反光等），建议重新调整后再上传',
              'error',
            );
            return;
          }
          //   if (res.data.ocrRecognition == false) {
          //     this.errorList.push(formData);
          //   }
          //   delete res.data['failFiles'];
          //   delete res.data['mess'];
          this.$emit('handleUpload', res.data, res.data.uploadStatus == false ? formData : null, {
            file: file,
          });
        });
        //   } else {
        //     this.$$message('运单已结算，不可更新证件信息', 'error');
        //   }
      }
    },
    // 进度条
    handleProgress(event, file, fileList) {
      console.log(event, file, fileList, 'handleProgress');
    },
    // 移除图片
    handleRemove() {
      this.$emit('handleRemove', this.code);
    },
    handlePreview() {
      this.$refs[this.code].clickHandler();
    },
  },
};
</script>

<style lang="scss" scoped>
.nf-upload-image {
  width: 105px;
  height: 70px;
  padding: 0 0 0 5px;

  ::v-deep .el-upload--picture-card {
    width: 94px;
    height: 66px;
    line-height: 66px;
    border: 0;

    .el-upload-dragger {
      width: 94px;
      height: 66px;
      line-height: 66px;
      border: 0;
      overflow: inherit;
    }
  }
  .ca-value {
    position: relative;
    width: 94px;
    height: 66px;
    border-radius: 4px;

    .ca-value-img {
      width: 94px;
      height: 66px;
      margin-top: -1px;
      margin-left: -2px;
      border-radius: 4px;
    }

    .ca-remove {
      position: absolute;
      font-size: 20px;
      color: #f36807;
      right: -7px;
      top: -7px;
      z-index: 999;
      background-color: #fff;
      border-radius: 10px;
      padding: 0;
      display: none;
    }

    .ca-pop {
      width: 94px;
      height: 66px;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.3);
      display: none;

      i {
        font-size: 20px;
        color: #ffffff;
        margin: 0 10px;
      }
    }
  }

  .ca-value:hover {
    .ca-pop {
      display: block;
    }

    .ca-remove {
      display: block;
    }
  }
}

.multiple-text {
  width: 480px;
  text-align: left;
}

.nf-unload-image-multiple {
  height: 40px;
  padding-left: 10px;
  padding-bottom: 5px;

  ::v-deep .el-upload--picture-card {
    height: 40px;
    line-height: 40px;
  }

  .nf-unload-image-multiple-button {
    width: 98px;
  }
}

.nf-unload-image-drag {
  width: 520px !important;
  height: 160px !important;
  padding: 0;
  cursor: none !important;
  text-align: left;
}
</style>
